import { render, staticRenderFns } from "./webNoticeList.vue?vue&type=template&id=053e2394&scoped=true&"
import script from "./webNoticeList.vue?vue&type=script&lang=js&"
export * from "./webNoticeList.vue?vue&type=script&lang=js&"
import style0 from "./webNoticeList.vue?vue&type=style&index=0&id=053e2394&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053e2394",
  null
  
)

export default component.exports